import { DATE_TEMPLATES, day, format, getToday } from '~/astra'
// Type-only: `~/storm` imports this module for a value, so a runtime import would close a cycle.
import type { LocationServiceOverride } from '~/storm'
import { closedReasonText } from '~/utils/locationServiceOverride'
import { ServicePeriod, workingWeekdays } from '~/utils/servicePeriods'

// Norwegian plural weekday form ("mandag" -> "mandager")
function toPluralWeekday(dayOfWeek: string) {
    return `${format(getToday().isoWeekday(Number(dayOfWeek)), DATE_TEMPLATES.fullWeekday)}er`
}

function formatClosedWeekdays(closedWeekdays: string[]) {
    // No need to list weekdays when the room is closed every working day (or, defensively, none match)
    if (closedWeekdays.length === 0 || closedWeekdays.length === workingWeekdays.length) return ''

    const names = closedWeekdays.map(toPluralWeekday)
    if (names.length === 1) return ` på ${names[0]}`
    return ` på ${names.slice(0, -1).join(', ')} og ${names[names.length - 1]}`
}

function formatDateRange(startDate: string | null | undefined, endDate: string | null | undefined) {
    const start = startDate ? format(day(startDate), DATE_TEMPLATES.longMonth) : undefined
    const end = endDate ? format(day(endDate), DATE_TEMPLATES.longMonth) : undefined

    if (start && end && startDate === endDate) return ` den ${start}`
    if (start && end) return ` fra ${start} til ${end}`
    if (start) return ` fra ${start} og fremover`
    if (end) return ` frem til ${end}`
    return ''
}

export type ClosedLocationText = {
    label: string
    description: string
}

export function getOverrideClosedLocationText(locationServiceOverride: LocationServiceOverride): ClosedLocationText {
    const label = closedReasonText[locationServiceOverride.closed_reason]

    return {
        label,
        description: `Stengt stue: ${label}`,
    }
}

export function getServicePeriodClosedLocationText(servicePeriod: ServicePeriod, closedWeekdays: string[]): ClosedLocationText {
    return {
        label: closedReasonText.service_period,
        description: `Stengt via Sykehusoppsett${formatClosedWeekdays(closedWeekdays)}${formatDateRange(servicePeriod.start_date, servicePeriod.end_date)}`,
    }
}
